import { lazy } from 'react';

export const Roles = lazy(() => import('./ui/Roles'));
